import Response from "./Response";

const STATUS_CLASSES = [
    "payment-summary__select--payment",
    "payment-summary__select--invoice",
    "payment-summary__select--automatic",
    "payment-summary__select--funds",
    "payment-summary__select--paid",
];

export default {
    init() {
        $(document).on("focus", "[data-payment-status-quick-edit]", function () {
            $(this).data("previous-status", $(this).val());
        });

        $(document).on("change", "[data-payment-status-quick-edit]", function () {
            const select = $(this);
            const previousStatus = select.data("previous-status");
            const selectedOption = select.find("option:selected");
            const statusClass = selectedOption.data("status-class");
            const data = { status: select.val() };

            data[yii.getCsrfParam()] = yii.getCsrfToken();
            select.prop("disabled", true).attr("aria-busy", "true");

            $.post(select.data("url"), data)
                .done((response) => {
                    if (response.status) {
                        select.removeClass(STATUS_CLASSES.join(" ")).addClass(statusClass);
                        select.data("previous-status", select.val());
                    } else {
                        select.val(previousStatus);
                    }
                    Response.handle(response);
                })
                .fail((xhr) => {
                    select.val(previousStatus);
                    Response.error(xhr);
                })
                .always(() => select.prop("disabled", false).removeAttr("aria-busy"));
        });
    },
};
